export default __webpack_public_path__ + "static/media/0172.567a9b63.jpg";